/* eslint-disable */
import ReportRtpList from './report-rtp.list';

export default {
  list: ReportRtpList,
};
